const impairments = [
    {
        "term": "Blind",
        "definition": "Lose an eye. Suffer -1 permanent accuracy. This injury is permanent and can be recorded twice. "+
                      "A survivor with two blind severe injuries suffers -4 permanent accuracy and retires at the end of the next showdown or settlement phase, having lost all sight."
    },
    {
        "term": "Broken Arm",
        "definition": "An ear-shattering crunch. Suffer -1 permanent accuracy and -1 permanent strength. This injury is permanent, and can be recorded twice."
    },
    {
        "term": "Broken Hip",
        "definition": "Your hip is dislocated. You can no longer dodge. Suffer -1 permanent movement. This injury is permanent, and can be recorded once. Gain 1 bleeding token."
    },
    {
        "term": "Broken Leg",
        "definition": "An ear-shattering crunch! Adjacent survivors suffer 1 brain damage. Suffer -1 permanent movement. This injury is permanent. and can be recorded twice."
    },
    {
        "term": "Broken Rib",
        "definition": "It even hurts to breathe. Suffer -1 permanent speed. This injury is permanent, and can be recorded multiple times."
    },
    {
        "term": "Contracture",
        "definition": "The arm will never be the same. Suffer -1 permanent accuracy. This injury is permanent, and can be recorded multiple times."
    },
    {
        "term": "Dead Inside",
        "definition": "You cannot gain survival."
    },
    {
        "term": "Deaf",
        "definition": "You won't hear it coming. Suffer -1 permanent evasion. This injury is permanent and can be recorded once."
    },
    {
        "term": "Destroyed Back",
        "definition": "A sharp crackling noise. Suffer -2 permanent movement. You can no longer activate any gear that has 2+ strength. This injury is permanent, and can be recorded once."
    },
    {
        "term": "Destroyed Genitals",
        "definition": "You cannot be nominated for Story EventIntimacy. This injury is permanent and can be recorded once. Gain a random disorder. You are knocked down. Gazing upwards, you wonder at the futility of your struggle. Gain +3 insanity."
    },
    {
        "term": "Dismembered Arm",
        "definition": "Lose an arm. You can no longer activate two-handed weapons. This injury is permanent, and can be recorded twice. A survivor with two dismembered arm severe injuries cannot activate any weapons."
    },
    {
        "term": "Dismembered Leg",
        "definition": "Lose a leg. You suffer -2 permanent movement. and can no longer dash. This injury is permanent. and can be recorded twice. "+
                      "A survivor with two dismembered leg severe injuries has lost both of their legs and must retire at the end of the next showdown or settlement phase."
    },
    {
        "term": "Endless Babble",
        "definition": "When you depart, departing survivors gain +1 insanity. You cannot encourage."
    },
    {
        "term": "Gaping Chest Wound",
        "definition": "Suffer -1 permanent strength. This injury is permanent, and can be recorded multiple times."
    },
    {
        "term": "Hamstrung",
        "definition": "A painful rip. The leg is unusable. You can no longer use any fighting arts or abilities. This injury is permanent. and can be recorded once."
    },
    {
        "term": "Intestinal Prolapse",
        "definition": "Your gut is gravely injured. You can no longer equip any gear on your waist, as it is too painful to wear. This injury is permanent, and can be recorded once."
    },
    {
        "term": "Intracranial Hemorrhage",
        "definition": "You can no longer use or gain any survival. This injury is permanent and can be recorded once."
    },
    {
        "term": "Leprosy",
        "definition": "Reduce all damage suffered by 1 to a minimum of 1. Suffer -2 to severe injury rolls."
    },
    {
        "term": "Marrow Hunger",
        "definition": "If the Murder or Skull Eater settlement events are drawn, nominate this survivor."
    },
    {
        "term": "Ruptured Muscle",
        "definition": "A painful rip. The arm hangs limp. You can no longer activate fighting arts. This injury is permanent, and can be recorded once."
    },
    {
        "term": "Shattered Jaw",
        "definition": "An impairment. You drink your meat through a straw. You can no longer consume or be affected by events requiring you to consume. You can no longer encourage. This injury is permanent and can be recorded once."
    },
    {
        "term": "Thin-Skinned",
        "definition": "You cannot gain insanity for any reason."
    },
    {
        "term": "Warped Pelvis",
        "definition": "Your pelvis is disfigured. Suffer -1 permanent luck. This injury is permanent and can be recorded multiple times."
    },
];


export default impairments;